export default {
  SET_OAUTH(state, payload) {
    Object.assign(state, payload);
  },
};
